import { useTranslation } from 'react-i18next';
import StandardModal, { ModalButtonType, ModalSize } from '../../Fundamentals/Modal/StandardModal';

export type VossFeatureFlagConfirm = { kind: 'toggle'; name: string; enabled: boolean } | { kind: 'delete'; name: string };

interface VossFeatureFlagConfirmModalProps {
    confirm: VossFeatureFlagConfirm;
    onConfirm: () => void;
}

// These flags change VOSS billing behaviour in production, so the text always says which flag, which new state and where.
const VossFeatureFlagConfirmModal = ({ confirm, onConfirm }: VossFeatureFlagConfirmModalProps) => {
    const { t } = useTranslation();

    if (confirm.kind === 'delete') {
        return (
            <StandardModal title={t('vossfeatureflags.deleteTitle')} size={ModalSize.SMALL} type={ModalButtonType.DELETE} onSubmit={onConfirm}>
                <p className="mb-0">{t('vossfeatureflags.deleteText', { name: confirm.name })}</p>
            </StandardModal>
        );
    }

    return (
        <StandardModal
            title={t('vossfeatureflags.toggleTitle')}
            size={ModalSize.SMALL}
            type={ModalButtonType.DEFAULT}
            submitLabel={t('vossfeatureflags.confirm') ?? ''}
            onSubmit={onConfirm}
        >
            <p className="mb-0">{t(confirm.enabled ? 'vossfeatureflags.toggleOn' : 'vossfeatureflags.toggleOff', { name: confirm.name })}</p>
        </StandardModal>
    );
};

export default VossFeatureFlagConfirmModal;
